import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static values = { issueId: Number }
  static targets = ['createExportButton', 'loadingIndicator', 'exportTitle']

  createIssueExport() {
    const id = this.issueIdValue
    const fileName = this.exportTitleTarget.value || ''
    const data = {
      title: fileName,
      file_format: 'pdf',
      origin: 'issues',
      search_attributes: {
        issues_ids: [id]
      }
    }

    const parametrizedReportData = $.param(data)
    event.currentTarget.classList.add('hidden')
    this.loadingIndicatorTarget.children[0].classList.remove('hidden')
    this.createExport(parametrizedReportData)
  }

  createExport(data) {
    Rails.ajax({
      type: 'POST',
      url: '/exports',
      dataType: 'json',
      data: data,
      success: (response) => {
        this.loadingIndicatorTarget.children[0].id = `export_${response.id}`
      },
      error: (data) => {
        // TODO
        console.log('Something went wrong.', data)
      }
    })
  }

  autoDownload(event) {
    const url = event.detail.downloadUrl
    window.open(url, '_blank')
  }
}
